import * as React from "react";

function VCToronto(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.982 6.907L10.25.137c-.173-.173-.37-.187-.544-.015L0 6.908v11.996c0 .73.551 1.052 1.288 1.052h3.93c.237 0 .433-.19.433-.434v-3.978h8.713v4.02a.44.44 0 00.434.436h3.828c.735 0 1.354-.604 1.354-1.312 0-.004.044-9.397.003-11.78z"
        fill="currentColor"
      />
      <path
        d="M17.686 18.54h-1.91v-3.766c-.088-.451-.74-.604-.961-.604H5.189c-.274-.017-.84.229-.929.638v3.732H2.32c-.47 0-.804-.337-.804-.546V7.692c.075-.117 8.496-5.703 8.496-5.703l8.497 5.703-.002 10.302c-.002.39-.369.547-.822.547z"
        fill="#fff"
      />
      <path
        d="M9.285 6.906v.946H7.423v5.243h-1.15V7.852H4.4v-.946h4.884z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.393 11.261c.152-.386.228-.805.228-1.26 0-.454-.076-.875-.228-1.261a2.992 2.992 0 00-.638-1 2.914 2.914 0 00-.989-.663 3.3 3.3 0 00-1.28-.24c-.468 0-.894.08-1.28.238A2.88 2.88 0 009.57 8.74 3.44 3.44 0 009.344 10c0 .454.075.875.227 1.261.152.387.366.721.64 1.004.276.283.607.504.994.662.385.156.813.236 1.281.236.468 0 .895-.08 1.28-.236a2.88 2.88 0 001.627-1.666zm-1.09-2.174c.09.27.135.575.135.914 0 .339-.044.644-.135.914-.09.27-.22.499-.388.686a1.675 1.675 0 01-.614.43c-.24.1-.512.15-.815.15-.3 0-.574-.048-.816-.15a1.702 1.702 0 01-.618-.43 1.895 1.895 0 01-.392-.686 2.797 2.797 0 01-.139-.914c0-.34.046-.644.14-.914.09-.27.221-.5.391-.688.17-.188.376-.332.618-.432.242-.1.514-.15.816-.15.302 0 .574.05.815.15.241.1.446.244.614.432.168.19.297.417.388.688z"
        fill="currentColor"
      />
    </svg>
  );
}

export default VCToronto;